import { z } from 'zod';

export const ManufacturerSchema = z
	.object({
		tradingName: z.string().optional(),
		businessName: z.string().optional(),
		cnpj: z.string().optional(),
	})
	.refine(data => data.tradingName || data.businessName, {
		message: 'Informe ao menos o Nome Comercial ou a Razão Social.',
		path: ['tradingName'],
	});

export type ManufacturerSchemaType = z.infer<typeof ManufacturerSchema>;
